// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject7":"Pokemon-module--seeLiveProject7--2vLJf","sourceCodeProject7":"Pokemon-module--sourceCodeProject7--1iD-v"};